import React from "react"
import { isEmpty, isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { configurations as configurationsSelector } from "reduxSlices/SAMLConfigurationsSlice"
import SAMLConfigurationsListItem from "./SAMLConfigurationsListItem"

const SAMLConfigurationsList = () => {
  const configurations = useSelector(configurationsSelector, isEqual)

  if (isEmpty(configurations)) {
    return (
      "The organization does not use single sign-on (SSO)."
    )
  }

  return (
    <div>
      {
        configurations.map((configuration) => (
          <SAMLConfigurationsListItem key={configuration.id} configuration={configuration} />
        ))
      }
    </div>
  )
}

export default SAMLConfigurationsList
